import { NotificationBars } from 'presentation/ui/components/notification-bars/NotificationBars';
import { FormLayout } from 'presentation/ui/layouts/form-layout/FormLayout';
import { useContext } from 'react';

import { L10nContext } from 'context/L10nContext';

import { NotificationBar } from 'presentation/ui/components/notification-bar/NotificationBar';
import { NotificationLevel } from 'presentation/ui/components/notification-bar/NotificationLevel';
import { ColumnLayoutSection } from 'presentation/ui/layouts/column-layout/column-layout-section/ColumnLayoutSection';
import { ColumnLayoutSectionMode } from 'presentation/ui/layouts/column-layout/column-layout-section/ColumnLayoutSectionMode';
import { ColumnLayout, ColumnLayoutMode } from 'presentation/ui/layouts/column-layout/ColumnLayout';
import { FormLayoutSection } from 'presentation/ui/layouts/form-layout/form-layout-section/FormLayoutSection';
import { FormLayoutSectionAlign } from 'presentation/ui/layouts/form-layout/FormLayoutSectionAlign';
import { ButtonPrimary } from 'presentation/ui/partials/button/button-primary/ButtonPrimary';
import { InputText } from 'presentation/ui/partials/input/input-text/InputText';
import { Label } from 'presentation/ui/partials/input/label/Label';
import { TextElement } from 'presentation/ui/partials/text-element/TextElement';

export interface DocumentEditFormStep1Props {
	onChange: (userInput: string) => void;
	onClickNext: () => void;
	documentName?: string;
	invalid?: boolean;
}

export const DocumentEditFormStep1 = (props: DocumentEditFormStep1Props): JSX.Element => {
	const { onChange, onClickNext, documentName, invalid = false } = props;

	const l10nContext = useContext(L10nContext);

	const safeDocumentName = documentName ?? '';
	const fileNameArray = safeDocumentName.split('.');
	const fileExtension = fileNameArray.length > 1 ? `.${fileNameArray.pop()}` : '';
	const fileName = fileNameArray.join('.');

	const notification = !invalid ?
		null :
		<NotificationBar
			level={NotificationLevel.LEVEL_ERROR}
			message={`${l10nContext.translate('view.documents.modal.action.edit.notificationError', 'Name darf nicht leer sein')}`}
		/>;

	return (
		<FormLayout align={FormLayoutSectionAlign.ALIGN_HORIZONTAL} onSubmit={onClickNext}>
			<NotificationBars>
				{notification}
			</NotificationBars>

			<FormLayoutSection>
				<Label label={`${l10nContext.translate('view.documents.modal.action.editDocument.documentName', 'Name')}*`}>
					<InputText
						type="text"
						defaultValue={fileName}
						onChange={(event) => onChange(event.target.value + fileExtension)}
						required
					/>
					<TextElement
						text={fileExtension}
					/>
				</Label>


			</FormLayoutSection>

			<FormLayoutSection align={FormLayoutSectionAlign.ALIGN_BOTTOM}>
				<ColumnLayout mode={ColumnLayoutMode.ALIGN_RIGHT}>
					<ColumnLayoutSection mode={ColumnLayoutSectionMode.MODE_FIXED}>
						<ButtonPrimary
							buttonText={l10nContext.translate('common.button.next', 'Weiter')}
							type="submit"
						/>
					</ColumnLayoutSection>
				</ColumnLayout>
			</FormLayoutSection>
		</FormLayout>
	);
};
